import type { Voyage } from "../../shared/api/types";

export function isoDateOnly(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function vesselKey(v: Pick<Voyage, "vesselCode" | "voyageNo">): string {
  return `${v.vesselCode}/${v.voyageNo}`;
}

// Default visible window for the vessels tab when the URL doesn't pin a range:
// 3 months past (1st of that month) → end of (current + 3) month.
export function defaultVesselsRange(): { from: string; to: string } {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth() - 3, 1);
  // Day 0 of next month = last day of the desired month.
  const to = new Date(now.getFullYear(), now.getMonth() + 4, 0);
  return { from: isoDateOnly(from), to: isoDateOnly(to) };
}
